<template>
    <section>

        <div style="width: 100%; height: 100%;">
            <el-row class="panel-group" style="width: 100%; height: 100%;">
                <el-col class="card-panel-col" style="float: left; width: 90%; height:90%; margin: 0">
                    <!--驾驶员查询-->
                    <div style="height:30px;position:fixed;z-index:999;">
                        <div style="float: left;">
                            <table align="center">
                                <tbody>
                                    <tr>
                                        <td>
                                            <el-select v-model="SelCourierId" @change="changeCourier" filterable placeholder="请选择驾驶员" style="width: 180px">
                                                <el-option :key="0" :value="0" :label="'全部'"></el-option>
                                                <el-option v-for="item in allCouriers"
                                                           :key="item.Id"
                                                           :label="item.Name"
                                                           :value="item.Id">
                                                    <span style="float: left">{{ item.Name }}</span>
                                                </el-option>
                                            </el-select>
                                        </td>
                                        <td>
                                            <el-date-picker v-model="GSPStartTime"
                                                            type="datetime"
                                                            placeholder="选择轨迹开始时间"
                                                            value-format="yyyy-MM-dd hh:ss"
                                                            format="yyyy-MM-dd hh:ss">
                                            </el-date-picker>
                                            <el-date-picker v-model="GSPEndTime"
                                                            type="datetime"
                                                            placeholder="选择轨迹结束时间"
                                                            value-format="yyyy-MM-dd hh:ss"
                                                            format="yyyy-MM-dd hh:ss">
                                            </el-date-picker>
                                        </td>
                                        <td>
                                            <el-button type="primary" size="small" @click="ShowCourierGps">查询轨迹</el-button>
                                        </td>

                                        <td>
                                            <el-button type="primary" size="small" @click="clearFnTrack" v-if="IsTrack">取消</el-button>
                                        </td>

                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>


                    <!--<div class="btnContainer">
                        <button class="btn1">点击小车开始移动</button>
                        <button class="btn2">重置</button>
                        <button class="btn3">暂停</button>
                        <button class="btn4">恢复</button>
                        <p>
                            <input type="text" placeholder="请输入限制移动距离" />
                            <button class="btn5">点击限制移动距离</button>
                        </p>
                        <div class="info">
                            <p></p>
                            <p>当前限制小车最大移动距离：0米</p>
                            <p>当前小车行驶距离：0米</p>
                            <p></p>
                        </div>
                    </div>-->
                    <!--车辆列表-->
                    <!--最小化-->
                    <div id="ierm2" v-show="!ShowCarListDiv && IsTrack" class="divHideCarList">
                        <div style="width: 100%; height: 28px; background-color: #fcfdfe; padding-top: 3px;">
                            <div style="width: 5px; height: 21px; float: left; margin-left: 10px;">
                                <img src="../../assets/bg.gif" width="5" height="21">
                            </div>
                            <div style="width: 215px; height: 21px; float: left; font-size: 12px; text-align: left;line-height: 21px;">
                                <strong>展开轨迹列表</strong>
                            </div>
                            <div style="height: 21px; float: right; margin-right: 10px;">
                                <span style="cursor: hand; margin-right: 4px;" title="还原">
                                    <img src="../../assets/up.png" @click="ShowCarList()">
                                </span>
                            </div>
                            <!--<div style="height: 21px; float: right; margin-right: 10px;">
                                <span style="cursor: hand; margin-right: 4px;" title="最大化">
                                    <img src="../../assets/max.png" style="width:21px;" @click="ShowMaxCarList()">
                                </span>
                            </div>-->
                        </div>
                    </div>
                    <!--展开-->
                    <div id="ierm" v-show="ShowCarListDiv&&IsTrack" :style="{width:CarListDivWidth,height:CarListDivHeight}" class="CarListStyle">
                        <table cellspacing="1" cellpadding="0" width="100%" bgcolor="#fcfdfe" border="0">
                            <tbody>
                                <tr>
                                    <td width="100%" height="17" align="center" valign="top">

                                        <div style="width: 100%; height: 28px; margin-top: 3px;">
                                            <div style="width: 5px; height: 36px; line-height: 36px; float: left; margin-left: 10px;">
                                                <img src="../../assets/bg.gif" width="5" height="21" style="padding-top: 8px;">
                                            </div>
                                            <div style="width: 500px; height: 36px; line-height: 36px; float: left; font-size: 12px; text-align: left;">
                                                <strong>查询结果--{{carsSearchMsg}}</strong>
                                            </div>

                                            <div style="height: 21px; float: right; margin-right: 10px;">
                                                <span style="cursor: hand; margin-right: 4px;" title="最小化" @click="HideCarList()">
                                                    <img src="../../assets/down.png">
                                                </span>
                                            </div>
                                            <!--<div style="height: 21px; float: right; margin-right: 10px;" v-show="!IsMaxCarListDiv">
                                                <span style="cursor: hand; margin-right: 4px;" title="最大化" @click="ShowMaxCarList()">
                                                    <img src="../../assets/max.png" style="height:21px;">
                                                </span>
                                            </div>-->
                                            <div style="height: 21px; float: right; margin-right: 10px;" v-show="IsMaxCarListDiv">
                                                <span style="cursor: hand; margin-right: 4px;" title="缩小" @click="ShowCarList()">
                                                    <img src="../../assets/min.png" style="height:21px;">
                                                </span>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td height="30" align="center" valign="middle" colspan="3">
                                        <div id="wierm" style="margin-left: 10px; margin-right: 10px;">
                                            <table width="100%" height="100%" border="0" cellpadding="0" cellspacing="0">
                                                <tbody>
                                                    <tr>
                                                        <td height="100%" align="left" style="font-size: 14px; padding: 0px;">


                                                            <div data-v-e4731dd0="" style="height: 30px;width:100%;font-weight:bold;">
                                                                <div data-v-e4731dd0="" class="tabCarListItem">
                                                                    <div style="width: 5%; float: left;">序号</div>
                                                                    <div style="width: 18%; float: left;">时间</div>
                                                                    <div style="width: 15%; float: left;">经度</div>
                                                                    <div style="width: 15%; float: left;">纬度</div>
                                                                    <div style="width: 47%; float: left;">地址</div>
                                                                </div>
                                                            </div>


                                                            <div id="tabCarList" :style="{height:CarListDivHeight2}" style="width: 100%;overflow:scroll;">
                                                                <!--<div class="tabCarListItem"><div style="width:21%;float:left;"><a href="javascript:BindSingleCar(&quot;桂X5118应急&quot;)">桂X5118应急</a></div><div style="width:26%;float:left;"><a href="javascript:void(0);" title="水罐消防车(SG)">水罐消防车(SG...</a></div><div style="width:11%;float:left;"><a href="javascript:void(0);" title="良好">良好</a></div><div style="width:16%;float:left;">水8.2...吨</div><div style="width:16%;float:left;">泡沫1...吨</div><div style="width:10%;float:left;"><a href="javascript:ShowTracking(&quot;桂X5118应急&quot;)">追踪</a></div></div>
                                                                <div class="tabCarListItem"><div style="width:21%;float:left;"><a href="javascript:BindSingleCar(&quot;桂X5192应急&quot;)">桂X5192应急</a></div><div style="width:26%;float:left;"><a href="javascript:void(0);" title="压缩空气泡沫消防车">压缩空气泡沫消防...</a></div><div style="width:11%;float:left;"><a href="javascript:void(0);" title="良好">良好</a></div><div style="width:16%;float:left;">水3.64...吨</div><div style="width:16%;float:left;">泡沫1.5...吨</div><div style="width:10%;float:left;"><a href="javascript:ShowTracking(&quot;桂X5192应急&quot;)">追踪</a></div></div>
                                                                <div class="tabCarListItem"><div style="width:21%;float:left;"><a href="javascript:BindSingleCar(&quot;桂X5235应急&quot;)">桂X5235应急</a></div><div style="width:26%;float:left;"><a href="javascript:void(0);" title="泡沫消防车(PM)">泡沫消防车(PM...</a></div><div style="width:11%;float:left;"><a href="javascript:void(0);" title="良好">良好</a></div><div style="width:16%;float:left;">水0...吨</div><div style="width:16%;float:left;">泡沫0...吨</div><div style="width:10%;float:left;"><a href="javascript:ShowTracking(&quot;桂X5235应急&quot;)">追踪</a></div></div><div class="tabCarListItem"><div style="width:21%;float:left;"><a href="javascript:BindSingleCar(&quot;桂X5272应急&quot;)">桂X5272应急</a></div><div style="width:26%;float:left;"><a href="javascript:void(0);" title="抢险救援消防车(JY)">抢险救援消防车(...</a></div><div style="width:11%;float:left;"><a href="javascript:void(0);" title="良好">良好</a></div><div style="width:16%;float:left;">水0...吨</div><div style="width:16%;float:left;">泡沫0...吨</div><div style="width:10%;float:left;"><a href="javascript:ShowTracking(&quot;桂X5272应急&quot;)">追踪</a></div></div><div class="tabCarListItem"><div style="width:21%;float:left;">桂X5081应急</div><div style="width:26%;float:left;"><a href="javascript:void(0);" title="云梯消防车(YT)">云梯消防车(YT...</a></div><div style="width:11%;float:left;">良好</div><div style="width:16%;float:left;">水0...吨</div><div style="width:16%;float:left;">泡沫0...吨</div><div style="width:10%;float:left;">无定位</div></div><div class="tabCarListItem"><div style="width:21%;float:left;"><a href="javascript:BindSingleCar(&quot;桂X5220应急&quot;)">桂X5220应急</a></div><div style="width:26%;float:left;"><a href="javascript:void(0);" title="水带敷设消防车(DF)">水带敷设消防车(...</a></div><div style="width:11%;float:left;"><a href="javascript:void(0);" title="良好">良好</a></div><div style="width:16%;float:left;">水0...吨</div><div style="width:16%;float:left;">泡沫0...吨</div><div style="width:10%;float:left;"><a href="javascript:ShowTracking(&quot;桂X5220应急&quot;)">追踪</a></div></div><div class="tabCarListItem"><div style="width:21%;float:left;">桂X5195应急</div><div style="width:26%;float:left;"><a href="javascript:void(0);" title="水罐消防车(SG)">水罐消防车(SG...</a></div><div style="width:11%;float:left;">良好</div><div style="width:16%;float:left;">水5...吨</div><div style="width:16%;float:left;">泡沫0...吨</div><div style="width:10%;float:left;">无定位</div></div><div class="tabCarListItem"><div style="width:21%;float:left;">桂X5024应急</div><div style="width:26%;float:left;"><a href="javascript:void(0);" title="强臂破拆车">强臂破拆车</a></div><div style="width:11%;float:left;">良好</div><div style="width:16%;float:left;">水0...吨</div><div style="width:16%;float:left;">泡沫0...吨</div><div style="width:10%;float:left;">无定位</div></div>-->

                                                                <div class="tabCarListItem" v-for="(car,index) in CourierAllGps">
                                                                    <div style="width:5%;float:left;">{{ index+1 }}</div>
                                                                    <div style="width:18%;float:left;" :title="car.CreationTime">{{ car.CreationTime|filterDateTime }}</div>
                                                                    <div style="width:15%;float:left;" :title="car.JDCHPHM">{{ car.Longitude}}</div>
                                                                    <div style="width:15%;float:left;" :title="car.ZB_MC">{{ car.Latitude }}</div>
                                                                    <div style="width:47%;float:left;">{{ car.AddressDetail|filterSub30 }}</div>

                                                                </div>



                                                            </div>
                                                        </td>

                                                    </tr>
                                                </tbody>
                                            </table>


                                        </div>
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                    </div>


                    <el-card class="welcome-card activeuser note">
                        <div id='divMap'></div>
                    </el-card>
                </el-col>

            </el-row>
        </div>

        <!--编辑界面-->
        <!--<el-dialog title="定位回放"
                   :visible.sync="editFormVisible"
                   v-model="editFormVisible"
                   :close-on-click-modal="false">
            <el-form :model="editForm" label-width="180px" :rules="editFormRules" ref="editForm">
                <el-form-item label="驾驶员" prop="GSPCourierId">
                    <el-input v-model="GSPCourierId" auto-complete="off" :readonly="true"></el-input>
                </el-form-item>
                <el-form-item label="开始时间" prop="GSPStartTime">
                    <el-date-picker v-model="editForm.GSPStartTime"
                                    type="datetime"
                                    placeholder="选择日期时间"
                                    value-format="yyyy-MM-dd HH:mm"
                                    @change="ChangeStartTime"
                                    format="yyyy-MM-dd HH:mm">
                    </el-date-picker>

                </el-form-item>
                <el-form-item label="结束时间" prop="GSPEndTime">
                    <el-date-picker v-model="editForm.GSPEndTime"
                                    type="datetime"
                                    placeholder="选择日期时间"
                                    @change="ChangeEndTime"
                                    value-format="yyyy-MM-dd HH:mm"
                                    format="yyyy-MM-dd HH:mm">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editCancel">取消</el-button>
                <el-button type="primary" @click.native="editSubmit" :loading="editLoading">确定</el-button>
            </div>
        </el-dialog>-->
        <!--<div class="btn-set-true" v-if="showGPSProgress">

            <div style="font-size: 12px;padding-left: 10px;padding-bottom: 10px;">开始时间：{{formatTime(GpsSearchStartTime)}} 结束时间：{{formatTime(GpsSearchEndTime)}}</div>-->
        <!-- 轨迹播放滑块 -->
        <!--<div class="playBox clearBoth">
                <div class="playIcon fl" v-if="isPlay">
                    <el-button type="text" v-if="palyStayus === 0" icon="el-icon-video-play" value="开始动画" @click="navgControl('start')" :disabled="beforeInit"></el-button>
                    <el-button type="text" v-if="palyStayus === 1" icon="el-icon-video-play" value="继续动画" @click="navgControl('resume')" :disabled="beforeInit"></el-button>
                </div>
                <div class="playIcon fl" v-if="!isPlay">
                    <el-button type="text" icon="el-icon-video-pause" value="暂停动画" @click="navgControl('pause')" :disabled="beforeInit"></el-button>
                </div>
                <div class="progress fl" style="margin-right: 0;">
                    <el-button type="text" icon="el-icon-d-arrow-left" value="减速" :disabled="isMinSpeed" @click="changeSpeed('less')"></el-button>
                </div>
                <div class="progress fl">
                    <el-button type="text" class="speed fl">{{ times }}X</el-button>
                </div>
                <div class="progress fl">
                    <el-button type="text" icon="el-icon-d-arrow-right" value="加速" :disabled="isMaxSpeed" @click="changeSpeed('add')"></el-button>
                </div>
            </div>
            <div class="progress fl" style="margin: 0 0 0 10px;">
                <el-slider v-model="sliderVal" :show-tooltip="false" :format-tooltip="hideFormat" :step="0.0001" :disabled="beforeInit" @change="carReLocate"></el-slider>
            </div>
        </div>-->




    </section>
</template>

<script>
    import util from "../../../util/date";
    /*  import address from "../../../util/address.json"; //全国省市区街道数据*/
    import {
        getAllCourier, getCourierGPSList
    } from "../../api/api";
    import { getButtonList } from "../../promissionRouter";
    /* import Toolbar from "../../components/Toolbar";*/

    export default {
        /* components: { Toolbar, VDistpicker },*/
        data() {
            return {


                markerUrl: require("../../assets/User64.png"),  // 点标记图片路径
                map: '',
                zoom: 12,  // 地图一开始的缩放级别
                center: new window.TMap.LatLng(31.385424, 120.980765),  // 地图一开始的中心点
                markerLayer: '',



                filters: {
                    name: "",
                },
                searchVal: "",
                //users: [],
                //roles: [],
                //options: [],
                //total: 0,
                //buttonList: [],
                //currentRow: null,
                //page: 1,
                listLoading: false,
                //sels: [], //列表选中列

                //////  省数据
                ////addressData: [],
                //////  市数据
                ////cityData: [],
                ////// 区数据
                ////areaData: [],

                ///*show: false,*/

                //addDialogFormVisible: false,
                //editFormVisible: false, //编辑界面是否显示
                //editLoading: false,
                //editFormRules: {
                //    GSPStartTime: [{ required: true, message: "请选择开始时间", trigger: "blur" }],
                //    GSPEndTime: [{ required: true, message: "请选择结束时间", trigger: "blur" }]
                //},
                ////编辑界面数据
                //editForm: {
                //    GSPStartTime: "",
                //    GSPEndTime: ""
                //},
                IsMaxCarListDiv: false,
                carsSearchMsg:"",
                CourierAllGps: [],
                CarListDivWidth: '750px',
                CarListDivHeight: '250px',
                CarListDivHeight2: '220px',
                ShowCarListDiv: false,
                SelCourierId: 0,
                allCouriers: [],
                GSPCourierId: 0,
                GSPStartTime: '',
                GSPEndTime: '',
                IsTrack: false,//记录当前是否在轨迹回放中
                markerArr: [],


                isMoving: false,
                path: [],
                limitDistance: 0, // 限制距离
                polylineLayer: null,
                gpsmarker: null,
                gpsGeometries: [],
            };
        },
        filters: {
            filterSub3: function (value) {
                if (value && value.length > 3) {  //字符最大长度
                    value = value.substring(0, 2) + "...";  //超过省略
                }
                return value;
            },
            filterSub9: function (value) {
                if (value && value.length > 9) {  //字符最大长度
                    value = value.substring(0, 8) + "...";  //超过省略
                }
                return value;
            },
            filterSub10: function (value) {
                if (value && value.length > 10) {  //字符最大长度
                    value = value.substring(0, 9) + "...";  //超过省略
                }
                return value;
            },
            filterSub12: function (value) {
                if (value && value.length > 12) {  //字符最大长度
                    value = value.substring(0, 11) + "...";  //超过省略
                }
                return value;
            },
            filterSub30: function (value) {
                if (value && value.length > 30) {  //字符最大长度
                    value = value.substring(0, 30) + "...";  //超过省略
                }
                return value;
            },
            //保留2位小数点过滤器 不四舍五入
            number2: function (value) {
                var toFixedNum = Number(value).toFixed(3);
                var realVal = toFixedNum.substring(0, toFixedNum.toString().length - 1);
                return realVal;
            },
            filterDateTime: function (value) {
                return !value || value == ""
                    ? ""
                    : util.formatDate.format(new Date(value), "yyyy-MM-dd hh:mm:ss");
            },

        },
        methods: {
            //dialogCheck(selection, row) {
            //    this.currentRow = null;
            //    this.$refs.table.clearSelection();
            //    if (selection.length === 0) {
            //        return;
            //    }
            //    if (row) {
            //        this.selectCurrentRow(row);
            //    }
            //},

            getHeight() {
                this.conheight.height = window.innerHeight - 190 + 'px';
            },
            //日期格式化
            formatTime(val) {
                if (val == null || val == "") {
                    return "";
                }
                let data = new Date(val);
                return util.formatDate.format(data, "yyyy-MM-dd hh:mm");
            },


            selectCurrentRow(val) {
                if (val) {
                    this.currentRow = val;
                    this.$refs.table.clearSelection();
                    this.$refs.table.toggleRowSelection(val, true);
                }
            },
            callFunction(item) {
                this.filters = {
                    name: item.search,
                };
                this[item.Func].apply(this, item);
            },
            formatCreateTime: function (row, column) {
                return !row.CreationTime || row.CreationTime == ""
                    ? ""
                    : util.formatDate.format(new Date(row.CreationTime), "yyyy-MM-dd");
            },
            ////性别显示转换
            //formatSex: function (row, column) {
            //    return row.sex == 1 ? "男" : row.sex == 0 ? "女" : "未知";
            //},
            //formatBirth: function (row, column) {
            //    return !row.birth || row.birth == ""
            //        ? ""
            //        : util.formatDate.format(new Date(row.birth), "yyyy-MM-dd");
            //},
            //handleCurrentChange(val) {
            //    this.page = val;
            //    this.handleQuery();
            //},
            ////获取用户列表
            //handleQuery() {
            //    let para = {
            //        page: this.page,
            //        key: this.searchVal,//this.filters.name,
            //    };
            //    this.listLoading = true;

            //    //testapi();
            //    //NProgress.start();
            //    getAllCourier(para).then((res) => {
            //        this.total = res.data.response.dataCount;
            //        this.users = res.data.response.data;
            //        this.listLoading = false;
            //        //NProgress.done();
            //    });
            //},

            HideCarList() {
                this.ShowCarListDiv = false;
            },
            //HideMinCarList() {
            //    this.ShowCarListDiv = false;
            //    this.IsMaxCarListDiv = false;
            //},
            ShowCarList() {
                this.ShowCarListDiv = true;
                //this.CarListStyle.width = 700 + 'px';

                //this.CarListDivWidth = '700px';
                //this.CarListDivHeight = '250px';
                //this.CarListDivHeight2 = '220px';

                var height = this.CourierAllGps.length * 30 + 50;
                console.log("height=" + height);
                if (height < 250) {
                    this.CarListDivWidth = '600px';
                    this.CarListDivHeight = (height + 30) + 'px';
                    this.CarListDivHeight2 = height + 'px';
                } else {
                    this.CarListDivWidth = '750px';
                    this.CarListDivHeight = '250px';
                    this.CarListDivHeight2 = '220px';
                }


                this.IsMaxCarListDiv = false;
            },
            ShowMaxCarList() {
                this.ShowCarListDiv = true;
                //this.CarListStyle.width = 800 + 'px';

                var height = this.CourierAllGps.length * 30 + 50;
                console.log("height=" + height);
                if (height < 550) {
                    this.CarListDivWidth = '600px';
                    this.CarListDivHeight = (height + 30) + 'px';
                    this.CarListDivHeight2 = height + 'px';
                } else {
                    this.CarListDivWidth = '750px';
                    this.CarListDivHeight = '550px';
                    this.CarListDivHeight2 = '520px';
                }

                this.IsMaxCarListDiv = true;
            },


            ChangeStartTime(value) {
                console.log("GSPStartTime=" + value);
                this.GSPStartTime = value;
            },
            ChangeEndTime(value) {
                console.log("GSPEndTime=" + value);
                this.GSPEndTime = value;
            },

            ////获取所有驾驶员
            //getAllCourierList() {
            //    //let _this = this;
            //    let para = {
            //    };
            //    this.listLoading = true;
            //    //NProgress.start();
            //    getAllCourier(para).then(res => {
            //        console.log(res);
            //        this.allCouriers = res.data.response;
            //        this.listLoading = false;

            //        //console.log("total=" + this.total);

            //        //NProgress.done();
            //    });
            //},


            changeCourier(value) {
                //if (value > 0) {
                //    this.handleChild(value, 1);
                //} else {
                //    this.SelCityId = -1;
                //    this.SelCounty = -1;
                //    //this.provinceList = [];
                //    this.cityList = [];
                //    this.countyList = [];
                //}
                if (value > 0) {
                    if (this.allCouriers != null && this.allCouriers.length > 0) {
                        for (var i = 0; i < this.allCouriers.length; i++) {
                            if (this.allCouriers[i].Id == value && this.allCouriers[i].Longitude > 0 && this.allCouriers[i].Latitude > 0) {
                                //this.map.setCenter(new TMap.LatLng(this.allCouriers[i].Longitude, this.allCouriers[i].Latitude));
                                this.map.easeTo({ zoom: 20, center: [this.allCouriers[i].Latitude, this.allCouriers[i].Longitude] }, { duration: 2000 });//平滑缩放,旋转到指定级别
                            }
                        }
                    }
                } else {
                    //缩小
                    //初始化
                    var bounds = new TMap.LatLngBounds();

                    //判断标注点是否在范围内
                    this.markerArr.forEach(function (item) {
                        //若坐标点不在范围内，扩大bounds范围
                        if (bounds.isEmpty() || !bounds.contains(item.position)) {
                            bounds.extend(item.position);
                        }
                    })
                    //设置地图可视范围
                    this.map.fitBounds(bounds, {
                        padding: 100 // 自适应边距
                    });
                }
            },
            clearFnTrack: function () {
                if (this.IsTrack == true) {
                    this.IsTrack = false;
                    this.gpsmarker.pauseMove();
                    //this.map.clear();// clearOverlays(); // 清除地图上的所有覆盖物
                    this.map.destroy(); // 销毁地图实例

                    this.initMap(this.center, this.zoom);  // 初始化页面后直接初始化地图

                }
            },
            //显示车辆轨迹
            ShowCourierGps: function () {
                this.$confirm("确认查询吗？", "提示", {}).then(() => {
                    this.listLoading = true;

                    this.carsSearchMsg = "";
                    this.CourierAllGps = [];


                    var courierId = this.SelCourierId;
                    var gpsStartTime = this.GSPStartTime;
                    var gpsEndTime = this.GSPEndTime;

                    if (courierId == null || courierId <= 0) {
                        this.$message({
                            message: "请选择驾驶员！",
                            type: "error"
                        });
                        this.listLoading = false;
                        return;
                    }
                    if (gpsStartTime == null || gpsStartTime == "") {
                        this.$message({
                            message: "请选择开始时间！",
                            type: "error"
                        });
                        this.listLoading = false;
                        return;
                    }
                    if (gpsEndTime == null || gpsEndTime == "") {
                        this.$message({
                            message: "请选择结束时间！",
                            type: "error"
                        });
                        this.listLoading = false;
                        return;
                    }

                    if (this.allCouriers != null && this.allCouriers.length > 0) {
                        for (var i = 0; i < this.allCouriers.length; i++) {
                            if (this.allCouriers[i].Id == courierId) {
                                this.carsSearchMsg = this.allCouriers[i].Name + "在" + gpsStartTime + "到" + gpsEndTime + "时间段内的轨迹数据：";
                                break;
                            }
                        }
                    }

                    let para = {
                        CourierId: courierId,
                        StartTime: gpsStartTime,
                        EndTime: gpsEndTime
                    };

                    getCourierGPSList(para).then(res => {
                        if (res.status == 200) {
                            this.path = [];
                            this.gpsGeometries = [];
                            this.CourierAllGps = res.data.response;
                            if (this.CourierAllGps != null && this.CourierAllGps.length > 0) {
                                for (var i = 0; i < this.CourierAllGps.length; i++) {
                                    this.path.push(new TMap.LatLng(this.CourierAllGps[i].Latitude, this.CourierAllGps[i].Longitude));
                                }
                                this.gpsGeometries.push({
                                    id: 'car',
                                    styleId: 'car-down',
                                    position: new TMap.LatLng(this.CourierAllGps[0].Latitude, this.CourierAllGps[0].Longitude),
                                });
                                this.gpsGeometries.push({
                                    id: 'start',
                                    styleId: 'start',
                                    position: new TMap.LatLng(this.CourierAllGps[0].Latitude, this.CourierAllGps[0].Longitude),
                                });
                                this.gpsGeometries.push({
                                    id: 'end',
                                    styleId: 'end',
                                    position: new TMap.LatLng(this.CourierAllGps[this.CourierAllGps.length - 1].Latitude, this.CourierAllGps[this.CourierAllGps.length - 1].Longitude),
                                });
                            }
                            this.IsTrack = true;


                            this.polylineLayer = new TMap.MultiPolyline({
                                map: this.map, // 绘制到目标地图
                                // 折线样式定义
                                styles: {
                                    style_blue: new TMap.PolylineStyle({
                                        color: '#ff8d00', // 线填充色
                                        width: 4, // 折线宽度
                                        borderWidth: 2, // 边线宽度
                                        borderColor: '#FFF', // 边线颜色
                                        lineCap: 'round', // 线端头方式
                                        eraseColor: 'rgb(172,172,172)',//擦除路径的颜色
                                    }),
                                },
                                geometries: [
                                    {
                                        id: 'erasePath',
                                        styleId: 'style_blue',
                                        paths: this.path,
                                    },
                                ],
                            });
                            this.gpsmarker = new TMap.MultiMarker({
                                map: this.map, // 绘制到目标地图
                                styles: {
                                    'car-down': new TMap.MarkerStyle({
                                        width: 40,
                                        height: 40,
                                        anchor: {
                                            x: 20,
                                            y: 20,
                                        },
                                        faceTo: 'map',
                                        rotate: 180,
                                        src: 'https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/car.png',
                                    }),
                                    start: new TMap.MarkerStyle({
                                        width: 25,
                                        height: 35,
                                        anchor: { x: 16, y: 32 },
                                        src: 'https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/start.png',
                                    }),
                                    end: new TMap.MarkerStyle({
                                        width: 25,
                                        height: 35,
                                        anchor: { x: 16, y: 32 },
                                        src: 'https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/end.png',
                                    }),
                                },
                                geometries: this.gpsGeometries,
                                //    [
                                //    {
                                //        id: 'car',
                                //        styleId: 'car-down',
                                //        position: new TMap.LatLng(39.98481500648338, 116.30571126937866),
                                //    },
                                //    {
                                //        id: 'start',
                                //        styleId: 'start',
                                //        position: new TMap.LatLng(39.98481500648338, 116.30571126937866),
                                //    },
                                //    {
                                //        id: 'end',
                                //        styleId: 'end',
                                //        position: new TMap.LatLng(39.978813710266024, 116.31699800491333),
                                //    },
                                //],
                            });

                            //初始化
                            var bounds = new TMap.LatLngBounds();

                            //判断标注点是否在范围内
                            this.path.forEach(function (item) {
                                //若坐标点不在范围内，扩大bounds范围
                                if (bounds.isEmpty() || !bounds.contains(item)) {
                                    bounds.extend(item);
                                }
                            })
                            //设置地图可视范围
                            this.map.fitBounds(bounds, {
                                padding: 100 // 自适应边距
                            });

                            this.startCar();

                        } else {
                            this.$message({
                                message: res.data.msg,
                                type: "error"
                            });
                            this.listLoading = false;
                        }
                    });


                    this.listLoading = false;
                });


            },
            pauseMove() {
                this.gpsmarker.pauseMove()
            },
            resumeMove() {
                this.gpsmarker.resumeMove()
            },
            startCar() {
                // 使用marker 移动接口， https://lbs.qq.com/webApi/javascriptGL/glDoc/glDocMarker
                //调用moveAlong动画 执行标记点动画开始
                this.gpsmarker.moveAlong(
                    {
                        car: {
                            path: this.path,//移动路径的坐标串
                            // duration:8000,//完成移动所需的时间，单位：毫秒
                            speed: 500, //speed为指定速度，正整数，单位：千米/小时
                        },
                    },
                    {
                        autoRotation: true,//自动旋转
                    }
                );
                //监听事件名
                this.gpsmarker.on('moving', (e) => {
                    var passedLatLngs = e.car && e.car.passedLatLngs;
                    if (passedLatLngs) {
                        // 使用路线擦除接口 eraseTo, https://lbs.qq.com/webApi/javascriptGL/glDoc/glDocVector
                        this.polylineLayer.eraseTo(
                            'erasePath',
                            passedLatLngs.length - 1,
                            passedLatLngs[passedLatLngs.length - 1]
                        );
                    }
                });

            },

            initMap(center, zoom) {
                this.map = new window.TMap.Map(document.getElementById('divMap'), {
                    center: center,//设置地图中心点坐标
                    zoom: zoom,   //设置地图缩放级别
                    pitch: 0,  //设置俯仰角
                    rotation: 0    //设置地图旋转角度
                });

                //this.markerLayer = new window.TMap.MultiMarker({  // 创建标记层
                //    map: this.map,  //指定地图容器
                //    geometries: [],
                //    styles: {  // 点标记样式
                //        "mystyle": new window.TMap.MarkerStyle({
                //            "width": 200,
                //            "height": 200,
                //            "src": this.markerUrl,
                //            "anchor": { x: 10, y: 10 },
                //            "opacity": 0.5
                //        })
                //    }
                //});

                //获取所有驾驶员
                //getAllCourierList() {
                //let _this = this;
                let para = {
                };
                this.listLoading = true;
                //NProgress.start();
                getAllCourier(para).then(res => {
                    console.log(res);
                    this.allCouriers = res.data.response;
                    this.listLoading = false;

                    this.markerArr = [];

                    if (this.allCouriers != null && this.allCouriers.length > 0) {
                        for (var i = 0; i < this.allCouriers.length; i++) {
                            //var couriersInfo = this.allCouriers[i];
                            if (this.allCouriers[i].Longitude > 0 && this.allCouriers[i].Latitude > 0) {
                                var title = "<div class='house-title'>";
                                //"   <div class='house-title-circle'></div>" +
                                //" <div class='close_img' onclick='closeInfoWindow()'><span class='min top_img'></span>" +
                                //// "   <div class='house-title-close'></div>" +
                                //"   " + couriersInfo.Id + "</div>";

                                var showInfo = title + "                                <div class='house-content'>" +
                                    "                                    <div class='pt-flexbox pt-flexbox-align-start pt-flexbox-justify-center' style='width:100%;'>" +
                                    "                                        <div class='pt-flexbox-item'>驾驶员</div>" +
                                    "                                        <div class='pt-flexbox-item text-right text-light-gray'>" + this.allCouriers[i].Name + "</div>" +
                                    "                                    </div>" +
                                    "                                    <div class='pt-flexbox pt-flexbox-align-start pt-flexbox-justify-center'>" +
                                    "                                        <div class='pt-flexbox-item'>定位时间</div>" +
                                    //"                                        <div class='pt-flexbox-item text-right text-light-gray'><a href=\"/EquipCarQuery/CarQueryList?DeptID=" + this.DeptGPSs[i]["DeptId"] + "\">" + this.DeptGPSs[i]["CarCount"] + "</a></div>" +
                                    //"                                        <div class='pt-flexbox-item text-right text-light-gray'><a target='_blank' href=\'/Summary/Report_Car_Dept_Detail?DeptId=" + this.DeptGPSs[i]["DeptId"] + "'\">" + this.DeptGPSs[i]["CarCount"] + "</a></div>" +
                                    //"                                        <div class='pt-flexbox-item text-right text-light-gray'><button onclick='OpenCarLink(\"" + deptInfo[0]["DeptId"] + "\")'>" + this.formatTime(this.cars[i]["GPSTime"]) + "</button></div>" +
                                    "                                        <div class='pt-flexbox-item text-right text-light-gray'>" + this.formatTime(this.allCouriers[i].GPSTime) + "</div>" +
                                    "                                    </div>" +
                                    "                                    <div class='pt-flexbox pt-flexbox-align-start pt-flexbox-justify-center'>" +
                                    "                                        <div class='pt-flexbox-item'>定位经度</div>" +
                                    //"                                        <div class='pt-flexbox-item text-right text-light-gray'><a href=\"/EquipCarQuery/EquipQueryList?DeptID=" + this.DeptGPSs[i]["DeptId"] + "\">" + this.DeptGPSs[i]["EquipCount"] + "</a></div>" +
                                    "                                        <div class='pt-flexbox-item text-right text-light-gray'>" + this.allCouriers[i].Longitude + "</div>" +
                                    "                                    </div>" +
                                    "                                    <div class='pt-flexbox pt-flexbox-align-start pt-flexbox-justify-center'>" +
                                    "                                        <div class='pt-flexbox-item'>定位纬度</div>" +
                                    "                                        <div class='pt-flexbox-item text-right text-light-gray'>" + this.allCouriers[i].Latitude + "</div>" +
                                    "                                    </div>" +
                                    "                                    <div class='pt-flexbox pt-flexbox-align-start pt-flexbox-justify-center'>" +
                                    "                                        <div class='pt-flexbox-item'>位置</div>" +
                                    "                                        <div class='pt-flexbox-item text-right text-light-gray divAddreessDetail'>" + this.allCouriers[i].AddressDetail + "</div>" +
                                    "                                    </div>" +
                                    //"                                    <div class='pt-flexbox pt-flexbox-align-start pt-flexbox-justify-center'>" +
                                    //"                                        <div class='pt-flexbox-item'>器材出入库</div>" +
                                    //"                                        <div class='pt-flexbox-item text-right text-light-gray'>查看详情</div>" +
                                    //"                                    </div>" +
                                    "                                </div>"
                                //"                            </div>" +
                                "                        </div>";


                                this.markerArr.push({
                                    "id": String(this.allCouriers[i].Id),
                                    "styleId": 'marker',
                                    "position": new TMap.LatLng(this.allCouriers[i].Latitude, this.allCouriers[i].Longitude),
                                    "content": this.allCouriers[i].Name, // 标注文本
                                    "properties": {
                                        "title": this.allCouriers[i].Name,
                                        "content": showInfo
                                    }
                                });
                            }
                        }
                    }
                    //初始化marker
                    var marker = new TMap.MultiMarker({
                        id: 'marker-layer',
                        map: this.map,
                        styles: {
                            "marker": new TMap.MarkerStyle({
                                "width": 25,
                                "height": 25,
                                "anchor": { x: 16, y: 32 },
                                "src": this.markerUrl,// 'https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/markerDefault.png',

                                "color": '#3777FF', // 颜色属性
                                "size": 20, // 文字大小属性
                                "offset": { x: 0, y: -20 }, // 文字偏移属性单位为像素
                                "angle": 0, // 文字旋转属性
                                "alignment": 'center', // 文字水平对齐属性
                                "verticalAlignment": 'middle', // 文字垂直对齐属性

                            }),
                            ////label: new TMap.LabelStyle({
                            ////    //color: '#3777FF', // 颜色属性
                            ////    //size: 20, // 文字大小属性
                            ////    //offset: { x: 0, y: 0 }, // 文字偏移属性单位为像素
                            ////    //angle: 0, // 文字旋转属性
                            ////    //alignment: 'center', // 文字水平对齐属性
                            ////    //verticalAlignment: 'middle', // 文字垂直对齐属性

                            ////    color: '#3777FF', // 颜色属性
                            ////    size: 20, // 文字大小属性
                            ////    width: 150, // 文字背景框宽度
                            ////    height: 60, // 文字背景框高度
                            ////    backgroundColor: 'rgba(175,238,238,0.6)', // 文字背景框颜色属性
                            ////    borderWidth: 4, // 文字背景框边线宽度
                            ////    borderRadius: 10,  // 文字背景框圆角
                            ////    borderColor: 'rgba(255,192,203,1.0)', // 文字背景框边线颜色

                            ////}),
                        },
                        geometries: this.markerArr
                    });
                    //初始化
                    var bounds = new TMap.LatLngBounds();

                    //判断标注点是否在范围内
                    this.markerArr.forEach(function (item) {
                        //若坐标点不在范围内，扩大bounds范围
                        if (bounds.isEmpty() || !bounds.contains(item.position)) {
                            bounds.extend(item.position);
                        }
                    })
                    //设置地图可视范围
                    this.map.fitBounds(bounds, {
                        padding: 100 // 自适应边距
                    });

                    ////初始化infoWindow
                    //var infoWindow = new TMap.InfoWindow({
                    //    map: map,
                    //    position: new TMap.LatLng(39.984104, 116.307503),
                    //    offset: { x: 0, y: -32 } //设置信息窗相对position偏移像素，为了使其显示在Marker的上方
                    //});
                    //infoWindow.close();//初始关闭信息窗关闭

                    var infoWindow = new TMap.InfoWindow({
                        map: this.map,
                        //enableCustom: true,
                        position: center,//new TMap.LatLng(39.984104, 116.307503),
                        offset: { x: 0, y: -48 }, //设置信息窗相对position偏移像素，为了使其显示在Marker的上方
                        content: "<div class='ref-card' style='width:220px;height:150px;white-space: break-word;background-color:white;text-align: center;padding: 0px 10px 5px;border-radius:6px;box-shadow:rgba(0, 0, 0, 0.15) 0px 2px 4px 0px;'></div>"
                    });
                    infoWindow.close();//初始关闭信息窗关闭
                    //const domParse = new DOMParser();
                    //监听标注点击事件
                    marker.on("click", function (evt) {
                        ////设置infoWindow
                        ////console.log("marker-evt");
                        ////console.log(evt);

                        ////var cId = evt.geometry.id;
                        ////console.log("cId=" + cId);
                        ////console.log(this.allCouriers);
                        var showInfo = evt.geometry.properties.content.toString();
                        ////console.log(showInfo);
                        ////初始化infoWindow
                        //var infoWindow = new TMap.InfoWindow({
                        //    map: this.map,
                        //    enableCustom: true,
                        //    position: new TMap.LatLng(evt.latLng.lat, evt.latLng.lng),
                        //    offset: { y: -70, x: -5 },
                        //    content:
                        //        showInfo,//'<div class="info_card"><div class="title"><span class="title_name">' + evt.geometry.content + evt.geometry.id + '</span><div class="close_img" onclick="closeInfoWindow()"><span class="min top_img"></span><span class="min right_img"></span><span class="min bottom_img"></span><span class="min left_img"></span></div></div><div align="left" class="content">点击右键变更内容</div><span class="cancle bot"></span><span class="cancle top"></span></div>',
                        //});

                        //infoWindow.open(); //打开信息窗

                        infoWindow.open(); //打开信息窗
                        infoWindow.setPosition(evt.geometry.position);//设置信息窗位置
                        //infoWindow.setContent(showInfo);//设置信息窗内容
                        document.querySelector(".ref-card").innerHTML = showInfo;;
                        //document.querySelector(".ref-card").append(showInfo);
                        //document.querySelector(".ref-card").append(domParse.parseFromString(showInfo, "text/html"));

                        //infoWindow.open(); //打开信息窗
                        //infoWindow.setPosition(evt.geometry.position);//设置信息窗位置
                        //infoWindow.setContent(evt.geometry.position.toString());//设置信息窗内容




                    })

                    // 关闭信息窗口的函数
                    function closeInfoWindow() {
                        infoWindow.close(); // 关闭信息窗口
                    }

                    //console.log("total=" + this.total);

                    //NProgress.done();
                });
                //},
            },
            //closeInfoWindow() {
            //    if (this.infoWindow) {
            //        this.infoWindow.close();
            //    }
            //},

            //// 添加点标记
            //addPoint(point) { // 一个point需要有id和坐标
            //    this.markerLayer.add([
            //        {
            //            'id': point['id'],
            //            'styleId': 'mystyle',
            //            "position": new window.TMap.LatLng(point['latitude'], point['longitude']),
            //            "properties": {} // 自定义属性，可以没有
            //        }
            //    ])
            //},

        },
        mounted() {
            this.initMap(this.center, this.zoom)  // 初始化页面后直接初始化地图
            //this.getAllCourierList();


            let routers = window.localStorage.router
                ? JSON.parse(window.localStorage.router)
                : [];
            this.buttonList = getButtonList(this.$route.path, routers);

            //this.buttonList.forEach(item => {
            //    if (item.Func == "handleEdit") {
            //        this.isEdit = true;
            //    }
            //    else if (item.Func == "handleDel") {
            //        this.isDelete = true;
            //    }
            //    else if (item.Func == "handleAdd") {
            //        this.isAdd = true;
            //    }
            //    else if (item.Func == "handleModifyPwd") {
            //        this.isModifyPwd = true;
            //    }
            //});

        },
    };
</script>
<style>
    .el-scrollbar__view {
        height: 100%;
        width: 100%;
    }

    #divMap {
        /*地图(容器)显示大小*/ /*设置为全屏，位于最下层*/
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0px;
        bottom: 0px;
        left: 0px;
        right: 0px;
        z-index: 99;
    }
</style>

<style scoped>
    .amazing /deep/ .el-badge__content {
        background-color: purple !important;
    }

    .bg-blue-sub-item {
        max-width: 120px !important;
        height: 50px;
        float: left;
        color: #fff;
        font-size: 12px;
        line-height: 50px;
        padding: 0 10px;
    }

        .bg-blue-sub-item .acc-user {
            max-width: 115px;
            display: block;
            overflow: hidden;
            text-overflow: ellipsis;
        }

    .bg-blue-sub-item-m {
        height: 50px;
        float: left;
        color: #fff;
        font-size: 12px;
        line-height: 50px;
        padding: 0 10px;
    }

        .bg-blue-sub-item-m .acc-user {
            display: block;
            overflow: hidden;
            text-overflow: ellipsis;
        }

    .note .text {
        font-size: 14px;
    }

    .note .item {
        margin-bottom: 18px;
    }
</style>

<style scoped>
    .map {
        width: 100%;
        min-height: 550px;
        height: auto;
    }

    .panel-group {
        margin-bottom: 18px;
        margin-right: 2%;
    }

    .card-panel-col {
        /* margin-bottom: 32px; */
        width: 113px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        margin-left: 15px;
        float: right;
    }

    .card-panel {
        height: 108px;
        font-size: 12px;
        position: relative;
        overflow: hidden;
        color: #666;
        background: #fff;
        box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.05);
        border-color: rgba(0, 0, 0, 0.05);
    }

        .card-panel .card-panel-icon-wrapper {
            color: #fff;
        }

        .card-panel .card-panel .icon-people {
            background: #40c9c6;
        }

        .card-panel .card-panel .icon-message {
            background: #36a3f7;
        }

        .card-panel .card-panel .icon-money {
            background: #f4516c;
        }

        .card-panel .card-panel .icon-shopping {
            background: #34bfa3;
        }

        .card-panel .icon-people {
            color: #40c9c6;
        }

        .card-panel .icon-message {
            color: #36a3f7;
        }

        .card-panel .icon-money {
            color: #f4516c;
        }

        .card-panel .icon-shopping {
            color: #34bfa3;
        }

        .card-panel .card-panel-icon-wrapper {
            float: left;
            margin: 14px 0 0 14px;
            padding: 16px;
            transition: all 0.38s ease-out;
            border-radius: 6px;
        }

        .card-panel .card-panel-icon {
            float: left;
            font-size: 48px;
        }

        .card-panel .card-panel-description {
            float: left;
            font-weight: bold;
            margin-left: 30px;
            margin-top: 20px;
        }

            .card-panel .card-panel-description .card-panel-text {
                line-height: 18px;
                color: rgba(0, 0, 0, 0.45);
                font-size: 16px;
                margin-bottom: 12px;
            }

            .card-panel .card-panel-description .card-panel-num {
                font-size: 36px;
                color: #f4516c;
            }

    .extoday {
        cursor: pointer;
    }

    .card-acuser-num {
        font-size: 36px;
        color: #40c9c6;
    }

    .bg-blue-sub-item /deep/ .el-badge__content.is-fixed {
        top: 5px !important;
    }

    .bg-blue-sub-item-m /deep/ .el-badge__content.is-fixed {
        top: 5px !important;
    }

    @media (max-width: 550px) {
        .note50 {
            width: 100% !important;
        }

        .statistical-cus {
            width: 100%;
        }

        .card-panel-col {
            margin-bottom: 5px !important;
            width: 100% !important;
        }

        .card-panel-icon-wrapper {
            float: none !important;
            width: 100%;
            height: 100%;
            margin: 0 !important;
        }

            .card-panel-icon-wrapper .svg-icon {
                display: block;
                margin: 14px auto !important;
                float: none !important;
            }
    }


    .CarListStyle {
        z-index: 99999;
        /*width: 700px;*/
        position: fixed;
        right: 50px;
        bottom: 50px;
        height: auto;
        /*max-height: 250px;*/
    }

    .EquipListStyle {
        z-index: 99999;
        /* width: 700px;*/
        position: fixed;
        left: 253px;
        bottom: 50px;
        height: auto;
        /* max-height: 250px;*/
        right: 50px;
    }


    .tabEquipListItem {
        background-color: #ecf1f6;
        margin-bottom: 5px;
        height: 25px;
        line-height: 25px;
        font-size: 12px;
        -webkit-box-shadow: #999 0px 0px 5px;
        -moz-box-shadow: #999 0px 0px 5px;
        box-shadow: #999 0px 0px 5px;
    }

    a:hover {
        text-decoration: none;
        font-size: 12px;
        color: #000;
    }

    .tabCarListItem {
        background-color: #ecf1f6;
        margin-bottom: 5px;
        height: 25px;
        line-height: 25px;
        font-size: 10px;
        -webkit-box-shadow: #999 0px 0px 5px;
        -moz-box-shadow: #999 0px 0px 5px;
        box-shadow: #999 0px 0px 5px;
    }

    .divHideEquipList {
        z-index: 99999;
        width: 400px;
        position: fixed;
        left: 253px;
        bottom: 50px;
        -webkit-box-shadow: #999 0px 0px 8px;
        -moz-box-shadow: #999 0px 0px 8px;
        box-shadow: #999 0px 0px 8px;
    }

    .divHideCarList {
        z-index: 99999;
        width: 320px;
        position: fixed;
        right: 50px;
        bottom: 50px;
        -webkit-box-shadow: #999 0px 0px 8px;
        -moz-box-shadow: #999 0px 0px 8px;
        box-shadow: #999 0px 0px 8px;
    }




    /*.el-input--medium .el-input__inner {
        height: 26px;
        line-height: 26px;
    }*/
</style>
<style>

    .amap-info-content {
        width: 300px;
        min-height: 160px;
        height: auto;
    }

    .house-info {
        width: 100%; /*12.88533rem;*/
        /* position: absolute;
        right: 0;
        top: 80px;*/ /*5.54667rem;*/
        height: 100%; /*6.4rem;*/
    }

    /*.house-info > div {
            height: 100%;
        }*/

    .house-title {
        color: #252525;
        font-weight: bold;
        font-size: 14px;
        line-height: 20px;
        padding: 0 5px;
        /*position: relative;*/
        margin-bottom: 5px;
        width: 90%;
        float: left;
    }

        .house-title .house-title-circle {
            position: absolute;
            left: 5px;
            top: 18px;
            height: 5px;
            width: 5px;
            border-radius: 50%;
            background-color: #296DCC;
        }

        .house-title .house-title-close {
            display: block;
            height: 10px;
            width: 10px;
            /*background-image: url(../img/close.png);*/
            background-position: center;
            background-size: 100%;
            position: absolute;
            right: 0;
            top: 5px;
        }

    .house-content {
        font-size: 12px;
        color: #252525;
    }

        .house-content > .pt-flexbox {
            margin-bottom: 5px;
        }


    .pt-flexbox-item {
        flex: auto;
        min-width: 70px;
    }

    .text-light-gray {
        color: #797979;
    }

    .text-right {
        text-align: right;
    }


    .pt-flexbox {
        display: flex;
        text-align: left;
        align-items: center;
    }

        .pt-flexbox.pt-flexbox-align-start {
            align-items: start;
        }

        .pt-flexbox.pt-flexbox-align-end {
            align-items: end;
        }

        .pt-flexbox.pt-flexbox-align-center {
            align-items: center;
        }

        .pt-flexbox.pt-flexbox-align-baseline {
            align-items: baseline;
        }

        .pt-flexbox.pt-flexbox-align-stretch {
            align-items: stretch;
        }

        .pt-flexbox.pt-flexbox-justify-start {
            justify-content: flex-start;
        }

        .pt-flexbox.pt-flexbox-justify-end {
            align-items: flex-end;
        }

        .pt-flexbox.pt-flexbox-justify-center {
            justify-content: center;
        }

        .pt-flexbox.pt-flexbox-justify-between {
            justify-content: space-between;
        }

        .pt-flexbox.pt-flexbox-justify-around {
            align-items: space-around;
        }

    .pt-flexbox-item:first-child {
        /* margin-left: 0; */
    }

    .flex-content {
        font-size: 0.512rem;
        color: #252525;
    }

        .flex-content > .pt-flexbox {
            margin-bottom: 0.512rem;
        }

        .flex-content.tiny > .pt-flexbox {
            margin-bottom: 0.34133rem;
        }



    .playBox {
        height: 25px;
        width: 275px;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-pack: center;
        justify-content: center;
        -ms-flex-align: center;
        align-items: center;
    }

        .playBox .el-button {
            padding: 0px;
            font-size: 25px;
        }

        .playBox .playIcon {
            height: 30px;
            display: inline-block;
            width: 30px;
            margin: 0 20px 0 25px;
        }

        .playBox .progress {
            display: inline-block;
            /*height: 35px;*/
            /*width: 300px;*/
            width: 60px;
            margin: 0px 15px;
        }

        .playBox .speed {
            font-size: 15px;
            font-weight: bolder;
            color: #1890FF;
            width: 40px;
            padding-left: 10px;
            text-align: center;
            cursor: pointer;
        }

        .playBox .fl {
            float: left;
        }

    .btn-set-true {
        /* display: flex; */
        z-index: 9999;
        position: fixed;
        bottom: 30px;
        width: 400px;
        /* left: 30px; */
        margin-left: 30px;
        /* height: 80px; */
        /* margin-top: 10px; */
        padding-top: 10px;
        box-shadow: #999 0px 0px 8px;
        background-color: white; /* 白色背景 */
        opacity: 0.9; /* 半透明 */
    }
    .divAddreessDetail {
        white-space: normal;
    }
</style>
